import { Spinner, Text, Tooltip } from "@radix-ui/themes";
import _ from "lodash";
import { twMerge } from "tailwind-merge";

export const CircleButton = (props: {
  onClick?: (e: any) => void;
  size?: "1" | "2" | "3" | "4";
  icon?: ({ className }: { className: string }) => JSX.Element;
  title?: string;
  tooltip?: string;
  src?: string;
  className?: string;
  loading?: boolean;
  badge?: string;
}) => {
  const { title, tooltip, onClick, icon, src, className, loading } = props;
  const size = props.size || "1";

  if (tooltip) {
    return (
      <Tooltip content={tooltip}>
        <div>
          <CircleButton {..._.omit(props, "tooltip")} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      className={twMerge(
        "text-center",
        size === "1"
          ? "w-8 h-8"
          : size === "2"
          ? "w-14 md:w-16"
          : size === "3"
          ? "w-16 md:w-20"
          : "w-20 md:w-24" // size 4
      )}
    >
      <div
        onClick={onClick}
        className={twMerge(
          "mx-auto flex items-center justify-center relative overflow-hidden",
          "cursor-pointer rounded-full bg-slate-100 border dark:border-slate-700 dark:bg-slate-900 hover:opacity-75",
          size === "1"
            ? "w-8 h-8"
            : size === "2"
            ? "w-12 h-12 md:w-14 md:h-14"
            : size === "3"
            ? "w-14 h-14 md:w-16 md:h-16"
            : "w-16 h-16 md:w-20 md:h-20", // size 4
          className
        )}
      >
        {!!src && (
          <div
            className={twMerge(
              "absolute top-0 left-0 w-full h-full bg-cover bg-center bg-no-repeat",
              loading && "blur-sm"
            )}
            style={{ backgroundImage: src ? `url(${src})` : undefined }}
          />
        )}
        {!!loading && <Spinner className="h-5 w-5" />}
        {!!icon &&
          icon({
            className:
              size === "1"
                ? "h-5 w-5"
                : size === "2"
                ? "h-6 w-6"
                : size === "3"
                ? "h-7 w-7"
                : "h-8 w-8", // size 4
          })}
        {!!props.badge && !loading && (
          <div
            className="absolute -bottom-0.5 bg-red-800 text-white font-bold rounded-md px-1.5 py-0.5"
            style={{ fontSize: "0.6rem" }}
          >
            {props.badge}
          </div>
        )}
      </div>
      <Text size="1" className={twMerge("block mt-2", !!title && "min-h-8")}>
        {title}
      </Text>
    </div>
  );
};
